import { ThemeToggle } from '@/components/ThemeToggle.tsx';
import { Menu, ScanLine } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NAV_ITEMS } from './nav.ts';

function sectionTitle(pathname: string): string {
  if (/^\/admin\/rezervasyonlar\/[^/]+$/.test(pathname) && !pathname.endsWith('/yeni')) {
    return 'Rezervasyon Detayı';
  }
  const match = [...NAV_ITEMS]
    .filter((n) => (n.end ? pathname === n.to : pathname.startsWith(n.to)))
    .sort((a, b) => b.to.length - a.to.length)[0];
  return match?.label ?? 'Yönetim';
}

type Props = {
  onOpenMenu: () => void;
  onOpenPalette: () => void;
};

export function Topbar({ onOpenMenu, onOpenPalette }: Props) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center justify-between gap-3 border-b border-border bg-bg/75 px-4 backdrop-blur-xl md:px-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onOpenMenu}
          aria-label="Menüyü aç"
          className="rounded-md p-2 text-text-muted transition-colors hover:bg-surface hover:text-text lg:hidden"
        >
          <Menu className="h-5 w-5" />
        </button>
        <h1 className="text-sm font-medium tracking-tight text-text">{sectionTitle(pathname)}</h1>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate('/admin?tara=1')}
          className="inline-flex h-9 items-center gap-2 rounded-md border border-border bg-bg-elevated px-3 text-xs text-text-muted transition-colors hover:border-border-strong hover:text-text"
        >
          <ScanLine className="h-4 w-4" />
          <span className="hidden sm:inline">Tara</span>
        </button>
        <button
          type="button"
          onClick={onOpenPalette}
          aria-label="Komut paleti"
          className="inline-flex h-9 items-center gap-2 rounded-md border border-border bg-bg-elevated px-3 text-xs text-text-muted transition-colors hover:border-border-strong hover:text-text"
        >
          <span className="hidden sm:inline">Ara</span>
          <kbd className="mono rounded border border-border-strong px-1.5 py-0.5 text-[10px] text-text-faint">
            ⌘K
          </kbd>
        </button>
        <ThemeToggle />
      </div>
    </header>
  );
}
